import { render, staticRenderFns } from "./QCteam.vue?vue&type=template&id=f720db9c&scoped=true"
import script from "./QCteam.vue?vue&type=script&lang=js"
export * from "./QCteam.vue?vue&type=script&lang=js"
import style0 from "./QCteam.vue?vue&type=style&index=0&id=f720db9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f720db9c",
  null
  
)

export default component.exports